import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  IconButton,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { ListLetter, DeleteLetter } from "../../services/letter";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import OptionMenu from "../../components/Menu";

function LetterList() {
  const navigate = useNavigate();

  const [letters, setLetters] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // -----------------------------
  // Fetch Letters
  // -----------------------------
  const fetchData = async () => {
    try {
      const response = await ListLetter();
      setLetters(response.data); // backend returns array
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching letters:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // -----------------------------
  // Actions
  // -----------------------------
  const handleDownload = async (id) => {
    try {
      window.location.href = `https://api.copysa.ir/api/Letter/DownloadLetter/${id}`;
    } catch (err) {
      Swal.fire({
        title: "خطا در دریافت اطلاعات",
        confirmButtonText: "باشه",
      });
    }
  };

  const handleEdit = (letter) => {
    navigate("/addletter", {
      state: { letterId: letter.idletterstr, mode: "edit" },
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "  حذف  نامه ",
      text: "آیا از حذف این نامه اطمینان دارید؟",
      icon: "warning",
      showCancelButton: true,

      confirmButtonText: " حذف ",
      cancelButtonText: "انصراف",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await DeleteLetter(id);
          Swal.fire("حذف شد!", "نامه با موفقیت حذف شد.", "success");
          fetchData();
        } catch (error) {
          console.error("Error deleting letter:", error);
          Swal.fire("خطا!", "مشکلی در حذف نامه رخ داد.", "error");
        }
      }
    });
  };

  // -----------------------------
  // Loading State
  // -----------------------------
  if (isLoading) return <p>در حال بارگذاری...</p>;

  // -----------------------------
  // Render
  // -----------------------------
  return (
    <Box className="flex flex-col gap-3  mb-24">
      {letters.map((letter) => (
        <Card
          key={letter.idletterstr}
          sx={{ my: 1, border: 1, borderColor: "#eeee" }}
        >
          <CardHeader
            sx={{ pb: 0 }}
            action={
              <OptionMenu
                iconButtonProps={{ size: "medium" }}
                iconClassName="text-textSecondary"
                options={[
                  {
                    text: "ویرایش",
                    // icon: <EditIcon color="action"/>,
                    menuItemProps: {
                      onClick: () => handleEdit(letter),
                    },
                  },
                  {
                    text: "حذف",
                    // icon: <DeleteIcon color="action"/>,
                    menuItemProps: {
                      onClick: () => handleDelete(letter.idletterstr),
                    },
                  },
                ]}
              />
            }
            title={`از: ${letter.sender}`}
            subheader={`به: ${letter.receiver}`}
          />

          <CardContent>
            <Typography sx={{ marginBottom: 2 }}>{letter.title}</Typography>
            <Typography sx={{ marginBottom: 1 }}>
              {letter.textletter}
            </Typography>
          </CardContent>
          <CardActions disableSpacing sx={{ justifyContent: "flex-end" }}>
            <IconButton
              aria-label="download"
              onClick={() => {
                handleDownload(letter.idletterstr);
              }}
            >
              <DownloadIcon />
            </IconButton>
          </CardActions>
        </Card>
      ))}
      <Box
        sx={{
          width: "100%",
          position: "fixed",
          left: 0,
          right: 0,
          bottom: "6.5rem", // Place above nav
          display: "flex",
          justifyContent: "start",
          px: 3,
          zIndex: 12,
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={() => navigate("/addletter")}
          sx={{
            padding: "15px 20px",
            borderRadius: "15px",
            border: "1px solid white",
            textTransform: "none",
          }}
        >
          <Typography variant="h5" sx={{ marginRight: "10px" }}>
            افزودن نامه
          </Typography>
          <AddIcon size="large" />
        </Button>
      </Box>
    </Box>
  );
}

export default LetterList;
